import { useEffect } from "react";

const { useState } = require("react");

export const useTimeAgo = (updateDate) => {
    const [time, setTime] = useState('');
  
    useEffect(() => {
        let intervalId
        const updateTime = () => {
            const now = Date.now()
            const updateTime = new Date(updateDate)
            const diff = Math.max(0, now - updateTime.getTime())
    
            const seconds = Math.max(Math.floor(diff / 1000),0)
            const minutes = Math.floor(seconds / 60)
            const hours = Math.floor(minutes / 60)

            const today = new Date(now)
            const yesterday = new Date()
            yesterday.setDate(yesterday.getDate() - 1)
            const isYesterday = (
                yesterday.getFullYear() === updateTime.getFullYear() &&
                yesterday.getMonth() === updateTime.getMonth() &&
                yesterday.getDate() === updateTime.getDate()
            );
    
            if (minutes < 1) {
                if (minutes === 0){
                    setTime("Updated now")
                }
                else{
                    setTime(`${seconds} ${seconds === 1 ? "second" : "seconds"} ago`)
                }
            } 
            else if (hours < 1) {
                setTime(`${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`)
            }
            else if (hours >= 1 && hours <= 12){
                setTime(`${hours} ${hours === 1 ? "hour" : "hours"} ago`)
            }
            else if (today.toDateString() === updateTime.toDateString()) {
                setTime('Today')
            }
            else if (isYesterday){
                setTime("Yesterday")
            }
            else {
                setTime(updateTime.toLocaleDateString("en-US", {
                    weekday: "short",
                    year: "numeric",
                    month: "short",
                    day: "numeric"
                }))
                return false
            }
            return true
        }

        let shouldContinue = updateTime()
        if (shouldContinue) {
            intervalId = setInterval(()=>{
                shouldContinue = updateTime()
                if (!shouldContinue){
                    clearInterval(intervalId)
                }
            }, 30000)
        }
        return () => {
            clearInterval(intervalId)
        }
    }, [updateDate]);
  
    return time;
  }
